module.exports = __webpack_public_path__ + "img/ic_baseline-telegram.ae229de7.svg";